<template>
    <div class="mb-4 jewelry_block col-lg-3 col-md-4 col-6" :class="{ 'col-lg-12 col-md-12 col-12 list_view mob-list-view-spacing' :viewType === 'list'}">
        <div class="" v-if="data.key === 'empty_state'">
            <img src="@/assets/assets/skeleton.jpg" width="600" height="600" alt="loading skeleton">
            <p class="placeholder-glow mb-0 mt-2">
                <span class="placeholder col-12 p-3"></span>
                <span class="placeholder col-6 p-2 my-2"></span>
            </p>
            <p class="placeholder-glow mb-0">
                <span class="placeholder col-1 p-3 me-1"></span>
                <span class="placeholder col-1 p-3 me-1"></span>
                <span class="placeholder col-1 p-3 me-1"></span>
            </p>
        </div>
        <div class="product_box" v-if="currentCarat && currentMetalList && currentMetalList.length">
            <div class="disc_chip_plp" v-if="!$country.is_india && currentCarat.discount_label">{{ currentCarat.discount_label }}% OFF</div>
            <div class="product-sku">{{ data.main_sku }}</div>
            <div v-if="currentCarat">

                <router-link :to="getDetailUrl(currentCarat.full_slug)" @click="triggerGtag({data, currentMetal, carats: currentMetal.carats, sub_module})" class="on_hover min_height">
                    <img loading="lazy" v-if="loader" width="246" class="loader_img mx-auto" height="246" alt="loader" src="~/assets/assets/loader.svg">
                    <div v-show="!loader" class="product_img_hover">
                        <img class="front_img mx-auto" width="246" height="246" :src="currentMetal.images.front" :alt="currentCarat.product_name + ' front view'">
                        <img loading="lazy" class="left_img mx-auto" width="246" height="246" :src="currentMetal.images.left" :alt="currentCarat.product_name + ' left view'">
                    </div>
                </router-link>
                <router-link :to="getDetailUrl(currentCarat.full_slug)" class="on_hover mb-0">
                    <h3 class="mb-3">{{currentCarat.product_name}}</h3>
                </router-link>
                <!-- mb-3 -->
                 <!-- :class="{'mb-0 price-min-height':!$country.is_india}" -->
                <h4  class="mb-3">
                    {{ $formatPrice(currentCarat.price) }}
                    <!-- <span class="india_price" v-if="$country.location == 'IN'">{{ $formatPrice( currentCarat.mrp ) }}</span>  -->
                    <span class="us_price" v-if="!$country.is_india && currentCarat.discount_label">{{ $formatPrice( currentCarat.mrp ) }}</span> 
                    <!-- lowest_price_label  -->
                    <span v-if="!$country.is_india && currentCarat.lowest_price_label && currentCarat.discount_label" class="lowest_price_plp mt-2">Lowest Price Ever</span>
                </h4>
            </div>
            <div class="metal_color d-flex mb-2 pb-1 align-items-center" v-if="currentMetalList && currentMetalList.length > 0">
                
                <div 
                    v-for="(metal, index) in currentMetalList" 
                    :key="index"
                    class="metal_box"
                    @click="selectMetal(metal.value)"
                    :class="{ 
                        'white': (metal.value === 4 || metal.value === 7 || metal.value === 10 ), 
                        'yellow': (metal.value === 5 || metal.value === 8), 
                        'rose': (metal.value === 6 || metal.value === 9),
                        'active': metal.selected === 1,
                        'metal_box_mod': !['band-ring', 'couple-bands-ring'].includes(sub_module)
                    }"
                    >
                    <span v-if="!['band-ring', 'couple-bands-ring'].includes(sub_module)">{{ metal.kt_label }}</span>
                </div>
            </div>

            <div v-if="currentMetal && currentMetal.carats && currentMetal.carats.length > 1">
                <div class="carat_list_block mt-3" ref="scrollContainer">
                    <div class="carat_list">
                        <div 
                            class="carat_box"   
                            :class="{ 'active': carats.selected === 1 }" 
                            v-for="carats in currentMetal.carats" 
                            :key="carats.slug"
                            @click="selectCarat(carats.slug)"
                            v-html="$formatCarat(carats.title)"
                        >
                        
                        </div>
                    </div>
                    
                </div>
                <div class="carat_label mt-1">Carats Available</div>
            </div>

            <div v-if="data.returnSize" class="avl_sizes mt-1">Sizes Available : {{ data.returnSize }}</div>
        </div>
    </div>   
</template>

<script setup> 
    import { cyolistStore }  from '@/stores/cyolist/cyolist';

    const store = cyolistStore();

    const { sub_module, data, viewType } = defineProps(['sub_module','data', 'viewType'])

    
    const localePath = useLocalePath()
    const { $formatPrice, $formatCarat, $country, $selectJewelryGtag } = useNuxtApp()
    const route = useRoute()
    const scrollContainer = ref(false)
    const moduleType = route.meta.moduleType
    const moduleSubType = route.meta.moduleSubType
    const metalOpen = ref(false)
    const showSkeleton = ref(true)
    const showMore = ref(false)
    const showGif = ref(false)
    const loader = ref(false)

    const currentMetalList = computed(() => {
        return data.metals
    })

    const currentMetal = computed(() => {

        if( data && data.metals ){

            return data.metals.find((metal) => {
                if(metal.selected === 1){
                    return metal
                }
            })
        }

        return null
    })

    const currentCarat = computed(() => {

        if( currentMetal.value && currentMetal.value.carats ){

            return currentMetal.value.carats.find((carat) => {
                if(carat.selected === 1){
                    return carat
                }
            })
        }
        return null
    })
    
    const fastshipOptions = computed(() => {
        return store.getSettingFilterOptions(sub_module , 'shipdate' )
    }) 
    
    const isFastshipActive = computed(() => {

        if(fastshipOptions.value){
            
            let selectedOption = fastshipOptions.value.find(cv=>   cv.active === 1 )
            console.log('selectedOption', selectedOption)
            if (selectedOption && ['3', '5', 3, 5].includes(selectedOption.value)) {
                return 'true'
            }
            return 'false'
        }
        return 'false'
    })

    onMounted(() =>{
        showGif.value = true
        showSkeleton.value = false
        initHorizontalScroll();


        if( typeof cls_InovaDiamonds_Iframe !== 'undefined' && cls_InovaDiamonds_Iframe.init_Session_Go !== undefined ){
            cls_InovaDiamonds_Iframe.init_Session_Go()
        }

        if(['full-eternity-ring', 'anniversary-ring', 'band-ring'].includes(moduleSubType)){
            const script = document.createElement('script');
            script.src = 'https://vto.jewelry/?d=6LYC9UW';
            script.async = true;
            script.onload = () => {
            };
            document.head.appendChild(script);
        }
    })
      
    function getDetailUrl(slug){

        return localePath({path: slug, query:{'FastShip': isFastshipActive.value}})
    }
    
    function getCaratLabel(carat){
        //check if numbers includes " "
        if (text.includes(" ")) {

            var main_number = text.split(/\s+/);
            // check if number includes ("/")
        
            var before_space = main_number[0]
            var after_space = main_number[1]

            var fraction = after_space.split('/')

            var before_slash = fraction[0]
            var after_slash = fraction[1]


            return `<p class="mb-0">${before_space}<span>  <sup>${before_slash}</sup>/<sub>${after_slash}</sub></span></p>`
        }
        if(!text.includes(" ") && text.includes("/")) {
            var fraction = text.split('/')

            var before_slash = fraction[0]
            var after_slash = fraction[1]

            return `<p class="mb-0"><sup>${before_slash}</sup>/<sub>${after_slash}</sub></p>`
        }

        return carat
    }
    function selectMetal(metal) {
        loader.value = true;
        
        data.metals.filter((item) =>{
            if(item.value === metal){
                item.selected = 1
            }else{
                item.selected = 0
            }
        }) 

        setTimeout(() => {
            loader.value = false;
        }, 1000);

    }

    function selectCarat(slug){

        if( currentMetal.value && currentMetal.value.carats ){

            currentMetal.value.carats.filter((item) =>{
                if(item.slug === slug){
                    item.selected = 1
                }else{
                    item.selected = 0
                }
            }) 
        }
        return null
    }

    function triggerGtag(data){
        // console.log(data)
        $selectJewelryGtag(data)
        return
    }

    function changeMetal(value) {
        data.metals.filter((metal) => {
            if(metal.value === value){
                metal.selected = true;
            }else{
                metal.selected = false
            }
            metalOpen.value = false;
            showSkeleton.value = true
            setTimeout(()=>{showSkeleton.value = false},1000)
        
        })
    }
    const isDown = ref(null)
    const startX = ref(null)
    const scrollLeft = ref(null)

    function initHorizontalScroll() {
        if(scrollContainer.value){
            const scrollContainerDiv = scrollContainer.value;

            scrollContainerDiv.addEventListener('mousedown', (e) => {
                isDown.value = true;
                startX.value = e.pageX - scrollContainerDiv.offsetLeft;
                scrollLeft.value = scrollContainerDiv.scrollLeft;
            });

            scrollContainerDiv.addEventListener('mouseleave', () => {
                isDown.value = false;
            });

            scrollContainerDiv.addEventListener('mouseup', () => {
                isDown.value = false;
            });

            scrollContainerDiv.addEventListener('mousemove', (e) => {
                if (!isDown.value) return;
                e.preventDefault();
                const x = e.pageX - scrollContainerDiv.offsetLeft;
                const walk = (x - startX.value) * 3; // Adjust scrolling speed here
                scrollContainerDiv.scrollLeft = scrollLeft.value - walk;
            });
        }
    }
</script>

<style scoped>
.avl_sizes {
    font-size: 14px;
    color: #606060;
    margin-top: 8px;
}
.product-sku {
    display: none;
}
.carat_label {
    font-size: 14px;
    color: #606060;
}
.empty_box {
    height: 73px;
}
.metal_box.active {
    pointer-events: none;
}
a.on_hover {
    display: block;
}
@media(min-width: 768px){
    .loader_img{
        display: block;
        width: 100%;
    }
}
.product_box {
    border: 1px solid #eaeaea;
    border-radius: 8px;
    padding: 15px;
    position: relative;
    overflow: hidden;
}

.product_box:hover{
    box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.15);
}
a{
    display: inline-block;
    color: #000;
}
h3 {
    color: #353535;
    font-size: 16px;
    font-weight: 400;
    line-height: 1.4;
    min-height: 50px;
}
h4 {
    color: #668b84;
    font-size: 18px;
    font-weight: 600;
}

h4.price-min-height{
    min-height: 50px;
}

h4 span.us_price {
    color: #656565;
    text-decoration: line-through;
    font-weight: 400;
    font-size: 14px;
}
h4 span.india_price {
    color: #656565;
    text-decoration: line-through;
    font-weight: 600;
    font-size: 14px;
    display: block;
    margin-top: 5px;
    
}
.metal_color .metal_box {
    height: 20px;
    width: 20px;
    /* margin-right: 7px; */
    cursor: pointer;
    /* border: 1px solid #fff;  */
    border-radius: 2px;
}

.metal_box_mod{
    height: 32px !important;
    width: 32px !important;
    /* margin-right: 7px; */
    cursor: pointer;
    border: 1px solid #fff;
    font-size: 11px;
    /* font-weight: 800; */
    display: flex;
    align-items: center;
    justify-content: center;
    color: #606060;
    letter-spacing: 0.5px;
    border-radius: 4px;
}
.metal_color .metal_box.active {
    height: 22px;
    width: 22px;
    border: 1px solid #353535;
}
.metal_color {
    gap: 8px;
}

.metal_color .yellow {
    background: #f3dda1;
}
.metal_color .rose {
    background: #f3b089;
}
.metal_color .white, .metal_color .platinum {
    background: #eff0f0;
}
p {
    color: #656565;
    font-size: 16px;
    font-weight: 300;
}
h5 {
    background: #f2f2f2;
    color: #656565;
    font-size: 13px;
    font-weight: 400;
    display: flex;
    align-items: center;
    justify-content: center;
    width: fit-content;
    padding: 4px 8px;
    position: absolute;
    top: 5px;
    left: 5px;
}
.carat_list {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 8px;
}

.carat_box {
    background: #f5f5f5;
    height: 32px;
    width: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    /* margin-right: 7px; */
    font-size: 11px;
    border: 1px solid #f5f5f5;
    cursor: pointer;
    border-radius: 2px;
    color: #606060;
}
.carat_list .carat_box:last-child {
    margin-right: 1px;
}
.carat_box.active {
    border: 1px solid #353535;
}
.carat_list_block {
    overflow-x: scroll;
    overflow-y: hidden;
    padding-bottom: 4px;
    height: 40px;
}

/* width */
.carat_list_block::-webkit-scrollbar {
  width: 2px;
  height: 3px;
}

/* Track */
.carat_list_block::-webkit-scrollbar-track {
  background: #f5f5f5; 
}
 
/* Handle */
.carat_list_block::-webkit-scrollbar-thumb {
  background: #c4c4c4; 
}

/* Handle on hover */
.carat_list_block::-webkit-scrollbar-thumb:hover {
  background: #c4c4c4; 
}
.carat_list {
    width: max-content !important;
}
@media(max-width: 992px){
    .product_box{
        padding: 10px;
    }
   
}
.v-zero{
    visibility: hidden;
    display: none;
}
@media(max-width: 767px){
    .loader_img{
        display: block;
        margin: 0 auto;
    }
   
    .min_height{
        min-height: 150px;
    }
    .carat_list_block {
        height: 40px;
    }
    .list_view .carat_list_block {
        display: flex;
        justify-content: center;
    }
    .carat_label, .avl_sizes{
        font-size: 10px;
        text-align: center;
    }
    .metal_box_mod{
        font-size: 10px;
        height: 32px !important;
        width: 32px !important;
        /* margin-right: 5px !important; */
    }
    .row .jewelry_block:nth-child(2n+2) {
        /* padding: 0;
        padding-right: 13px;
        padding-left: 5px; */
        padding: 7px 12px 7px 7px;

    }
    .row .jewelry_block:nth-child(2n+1) {
        /* padding: 0;
        padding-left: 13px;
        padding-right: 5px; */
        padding: 7px 7px 7px 12px;

    }
    .jewelry_block {
        margin-bottom: 0px !important;
    }
    .product_img_hover{
        text-align: center;
    }
    h4 {
        font-size: 16px;
        font-weight: 600;
        color: #668b84;
    }
    h3, p {
        font-size: 14px;
     
    }
    .empty_box {
        height: 60px;
    }    

    h5{
        padding: 3px 6px;
        font-size: 12px;
    }
    h4 span {
        font-size: 16px;
    }
    .carat_box {
        height: 32px;
        width: 32px;
        /* margin-right: 5px; */
        font-size: 10px;
    }

    .list_view a{
        display: block;
    }
    .list_view h3{
        text-align: center;
        min-height: auto;
    }
    .list_view h4{
        text-align: center;
    }
    .list_view .metal_color {
        justify-content: center;
    }
    .list_view p{
        text-align: center;
    }
    .list_view{
        padding: 0;
        padding-left: 13px !important;
        padding-right: 13px !important;
    }
}

</style>
